<app-header></app-header>
<!--Breadcrumb-->
        <section>
            <div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center">
                            <h1 class="">Tell Us Your Preferences</h1>
                            <!--ol class="breadcrumb text-center">
                                <li class="breadcrumb-item"><a href="home.html">Home</a></li>
                                <li class="breadcrumb-item active text-white">My Dashboard</li>
                                <li class="breadcrumb-item active text-white" aria-current="page">My Preferences</li>
                            </ol-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Breadcrumb-->

        <!--Section-->
        <section class="sptb">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-12 col-md-12">
                        <!-- my account left menu -->
                <app-my-account-left-menu></app-my-account-left-menu>
                <!-- /my account left menu -->
                    </div>
                    <div class="col-xl-9 col-lg-12 col-md-12">
                        <div class="card mb-0">
                            <div class="card-header  d-sm-flex title-set">
                                <h3 class="card-title">Edit Preferences</h3>
                            </div>
                            <form [formGroup]="myPrefFromGroup" (submit)="proceedSavePreference(myPrefFromGroup.value)">
                            <div class="card-body">
                                <div class="row">                                
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                        <label class="form-label">Preferred Car State </label>
                                            <div class="input-group  pt-4  pb-4 prefebtn" style="">
                                            <select id="preferred_state2" multiple class="form-control">
                                                <option *ngFor="let state of preferredStateList" [selected] = "selectedPrefStateIdsArray.indexOf(state.id+'')>-1" value="{{state.id}}">{{state.name}}</option>
                                                <option *ngFor="let state of otherStateList" [selected] = "selectedPrefStateIdsArray.indexOf(state.id+'')>-1" value="{{state.id}}">{{state.name}}</option>
                                                </select>
                                                <input #selectedPreferredState type="hidden" id="selected_preferred_state2"/>
                                            <!-- <select  class="form-control" (change)="selectState($event.target.value)">
                                            <optgroup label="States"> -->
													<!-- <option value="0">--Select--</option> -->
                                                    <!-- <option disabled>---Preferred State-----</option> -->
													<!-- <option *ngFor="let state of preferredStateList" value="{{state.id}}">{{state.name}}</option> -->
                                                    <!-- <option disabled>---Other State-----</option>
                                                    <option *ngFor="let state of otherStateList" value="{{state.id}}">{{state.name}}</option>													 -->
												<!-- </optgroup>
                                            </select> -->
												<!-- <input type="search" class="form-control" id="name1" placeholder="Search Preferred States">
													<div class="input-group-append ">
														<button type="button" class="btn btn-primary br-tr-3  br-br-3"> <i class="fa fa-search" aria-hidden="true"></i> </button>
													</div> -->
                                             <input type="hidden" formControlName="prefStates"/>        
											</div>
                                        </div>
                                    </div> 
                                       
				<div class="col-sm-12 col-md-6">
                
								
									
									<!-- <div class="card-body">
										<a class="view-state" data-toggle="modal" data-target="#exampleModal3">View All States</a>
									
								</div> -->
							</div>									
                                   
                               <!-- <div class="col-sm-12 col-md-12">
								<div class="">
										<div class="slet-btn">
										<span *ngFor="let stateId of selectedPrefStateIdsArray" class="span-icon">{{allStateList[stateId]}}<i class=" fa fa-times" (click)="removeState(stateId)"></i></span>										
										</div>
								</div>
							</div>									 -->
                                         
                                    
                                   
                                    
                                    <div class="col-md-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Preferred Car Segment </label>
                                            <div class="selectgroup"  style="">
                                               <label class="selectgroup-item mb-md-0" formArrayName="prefSegment" *ngFor="let segment of myPrefFromGroup.controls.prefSegment.controls; let i = index">
                                                <input type="checkbox" class="selectgroup-input" [formControlName]="i">
                                                <span class="selectgroup-button">{{segmentArray[i].name}}</span>
                                                </label>
                                                <!-- <label class="selectgroup-item mb-md-0 mr-2">
                                                    <input type="checkbox" name="value" value="perol" class="selectgroup-input">
                                                    <span class="selectgroup-button">Luxury Cars</span>
                                                </label>
                                                <label class="selectgroup-item mb-md-0  mr-2">
                                                    <input type="checkbox" name="value" value="diesel" class="selectgroup-input">
                                                    <span class="selectgroup-button">Low Segment Cars</span>
                                                </label>
                                                <label class="selectgroup-item mb-0  mr-2">
                                                    <input type="checkbox" name="value" value="other" class="selectgroup-input">
                                                    <span class="selectgroup-button">Mid Segment Cars</span>
                                                </label>                                                         -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-8">
                                         <label class="form-label">Preferred Price Range</label>
                                          <input type="text" id="pre_range">
                                          <input #rangeFrom type="hidden"  formControlName="prefPriceRangeFrom" id="pre_range_from">
                                          <input #rangeTo type="hidden"  formControlName="prefPriceRangeTo" id="pre_range_to">
                                        </div>
                                        <div class="form-group col-md-12">
                                        <div class="form-group">
                                            <label class="form-label">Preferred Car Brands</label>
                                            <div class="selectgroup"  style="overflow-y: hidden;overflow-x: scroll;width:100%;">
                                            <label class="selectgroup-item mb-md-0" formArrayName="prefBrand" *ngFor="let brand of myPrefFromGroup.controls.prefBrand.controls; let i = index">
                                                <input type="checkbox" class="selectgroup-input" [formControlName]="i">
                                                <span class="selectgroup-button">{{brandArray[i].name}}</span>
                                                </label>
                                                <!-- <label class="selectgroup-item mb-md-0">
                                                    <input type="checkbox" name="value" value="all" class="selectgroup-input" checked="">
                                                    <span class="selectgroup-button">Maruti Suzuki </span>
                                                </label>
                                                <label class="selectgroup-item mb-md-0">
                                                    <input type="checkbox" name="value" value="perol" class="selectgroup-input">
                                                    <span class="selectgroup-button">Hyundai</span>
                                                </label>
                                                <label class="selectgroup-item mb-md-0">
                                                    <input type="checkbox" name="value" value="diesel" class="selectgroup-input">
                                                    <span class="selectgroup-button">Honda</span>
                                                </label>
                                                <label class="selectgroup-item mb-0">
                                                    <input type="checkbox" name="value" value="other" class="selectgroup-input">
                                                    <span class="selectgroup-button">Tata</span>
                                                </label>                                                         -->
                                            </div>
                                        </div>
                                    </div>
                                        
								 <div class="form-group col-md-5 mt-5">
                                     <button type="Submit" class="btn btn-primary ">{{updateBtnLabel}}</button>
                                  </div>
                                  
                                    <!-- <div class="col-sm-6 col-md-6">
                                        <label class="form-label">Price Range</label>                                    
                                        <input type="text" id="price">                                        
                                        <div id="mySlider" class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"><div class="ui-slider-range ui-widget-header ui-corner-all" style="left: 0%; width: 49.9499%;"></div><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style="left: 0%;"></span><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style="left: 49.9499%;"></span></div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <label class="form-label">KM Driven</label>                                    
                                        <input type="text" id="km_driven">                                        
                                        <div id="km_driven_slider" class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"><div class="ui-slider-range ui-widget-header ui-corner-all" style="left: 0%; width: 49.9499%;"></div><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style="left: 0%;"></span><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style="left: 49.9499%;"></span></div>
                                    </div> -->
                                </div>    
                            </div>
                            </form>
                        </div>
                       
                    </div>
                    
                </div>
                
            </div>
                 
    </section>
    <!--/Section-->
<app-footer></app-footer>
